function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 2C6.39768 2 4.94214 2.62839 3.86616 3.65188L2.49714 2.28286C2.22366 2.00938 2 2.10205 2 2.48884L2 5.58259C2 6.18017 2.09777 6.28571 2.70312 6.28571L5.79687 6.28571C6.18366 6.28571 6.27634 6.06205 6.00286 5.78857L4.92714 4.71286C5.76366 3.92964 6.84875 3.5 8 3.5C9.20187 3.5 10.332 3.96821 11.1819 4.81812C12.0318 5.66804 12.5 6.79813 12.5 8C12.5 9.20187 12.0318 10.332 11.1819 11.1821C10.332 12.0318 9.20187 12.5 8 12.5C6.79813 12.5 5.66804 12.0318 4.81812 11.1819C4.74714 11.1109 4.67911 11.0378 4.61348 10.963L3.48473 11.9509C4.58455 13.2069 6.19946 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68634 11.3137 2 8 2V2Z",
  fill: "currentColor"
});
const SvgUpdated = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpdated, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/updated.ae12f19c.svg";
export { ForwardRef as ReactComponent };